import ActionButton from '~/components/dynamic_table/components/ActionButton'
import DynamicTable from '~/components/dynamic_table/dynamic_table'
import { formatValue } from '~/components/dynamic_table/helpers/formatValue'

export default function SimpleTable({ context, url, fixedQuery, ...props }) {
  const renderObject = (resource, index, target) => {
    const method = resource.data?.['turbo-method'] || 'get'
    const className = resource.class || []
    const confirm = resource.data?.['turbo-confirm']
    const data = resource.data || {}
    const formMethod = method === 'get' ? 'get' : 'post'

    return (
      <ActionButton
        key={index || JSON.stringify(resource)}
        label={resource.label}
        url={resource.url}
        method={method}
        formMethod={formMethod}
        className={className}
        confirm={confirm}
        token={context.token}
        data={data}
        target={target}
      />
    )
  }

  const renderLink = (resource, index, target) => {
    if (resource == null) return <span className='text-muted'>—</span>
    if (typeof resource === 'object' && resource.url) {
      resource.class = `${resource.class} me-2`
      return renderObject(resource, index, target)
    }

    return <ActionButton label={formatValue(resource)} url={resource.url} method='get' target={target} />
  }

  // Modify columns to render links if they have a link property
  context.columns.forEach((column) => {
    if (column.link) {
      column.render = (row) => {
        const subject = row[column.key]
        if (Array.isArray(subject)) {
          return subject.map((resource, index) => renderLink(resource, index, column.target))
        }
        return renderLink(subject, undefined, column.target)
      }
    }
  })

  return <DynamicTable {...props} url={url} columns={context.columns} fixedQuery={fixedQuery} />
}
